<template>
  <div>
    <b-row>
      <b-col
          md="3"
          sm="3"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />

        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="2"
          class="my-1"
      >
        <label class="d-inline-block text-sm-left mr-50">Option Filter</label>
        <b-form-select
            id="perPageSelect"
            v-model="filterOption"
            size="sm"
            :options="FilterOptions"
            class="w-50"
        />
      </b-col>

      <b-col
          md="7"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Fahrer Name oder Ähnl."
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
            <b-button
                size="sm"
                class="ml-2 btn-info"
                @click="OpenUploadPayroll"
            >
              Lohnbescheinigung
            </b-button>

            <b-button
                size="sm"
                class="ml-2 btn-success"
                @click="Add"
            >
              Neuen Fahrer anlegen
            </b-button>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">
        <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="drivers"
            :fields="fields"
        >
          <template #cell(DriverShortName)="data">
            <b-badge @click="ClickRow(data.item)" v-bind:style="{color: data.item.Driver.Color2, background: data.item.Driver.Color1}">
              {{ data.item.Driver.DriverShortName }}
            </b-badge>
          </template>

          <template #cell(Contact.Name)="data">
            <div @click="ClickRow(data.item)">{{ data.item.Driver.Contact.Name }}</div>
          </template>

          <template #cell(EntryDateLeavingDate)="data">
            <b-badge
                pill
                variant="info"
            >
              {{ formatDate(data.item.Driver.EntryDate) }} {{ (data.item.Driver.LeavingDate == null ? '' : '/ ' + formatDate(data.item.Driver.LeavingDate)) }}
            </b-badge>
          </template>


          <template #cell(PassengerTransportTicket)="data">
            <b-badge
                pill
                variant="danger"
                v-show="new Date(data.item.Driver.PassengerTransportTicket) <= new Date()"
            >
              {{ formatDate(data.item.Driver.PassengerTransportTicket) }}
            </b-badge>
            <b-badge
                pill
                variant="success"
                v-show="new Date(data.item.Driver.PassengerTransportTicket) > new Date()"
            >
              {{ formatDate(data.item.Driver.PassengerTransportTicket) }}
            </b-badge>
          </template>

          <template #cell(Vehicle)="data">
            {{ data.item.Vehicle != null ? data.item.Vehicle.NumberPlate : '-' }} ({{ data.item.Vehicle != null ? data.item.Vehicle.Name : '' }})
          </template>

          <template #cell(PushoverId)="data">
            <img :src="pushoverLogo" alt="Logo" width="32" style="filter: grayscale(0)" v-show="data.item.Driver.PushoverId > 0"/>
            <img :src="pushoverLogo" alt="Logo" width="32" style="filter: grayscale(1)" v-show="data.item.Driver.PushoverId == 0"/>
          </template>
          <template #cell(FirmPhone)="data">
            <img :src="phoneIcon" alt="Logo" width="32" style="filter: grayscale(1)" v-show="!data.item.IsCurrentFirmPhoneDriver" @click="SetFirmPhone(data.item.Driver.DId)"/>
            <img :src="phoneIcon" alt="Logo" width="32" style="filter: grayscale(0)" v-show="data.item.IsCurrentFirmPhoneDriver" @click="SetFirmPhone(0)"/>
          </template>
        </b-table>
      </b-col>


      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>

    <b-modal
        no-close-on-backdrop
        hide-footer
        id="modal-payroll-driver"
        centered
        size="lg"
        title="Lohnabrechnungen Hochladen"
    >
      <b-row>

        <b-form-group
            label=""
        >
          <b-form-file
              v-model="SelectedPayrollFile"
              placeholder="Datei auswählen"
              drop-placeholder="Datei herreinziehen"
          />
        </b-form-group>

      </b-row>

      <div>
        <b-button class="float-right" variant="success" @click="UploadPayroll">

          <span v-show="!loading.payroll.upload"> jetzt Hochladen </span>
          <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
          <div
              v-show="loading.payroll.upload"
              class="spinner-border spinner-border-sm"
              role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>

        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>

    <b-modal
        no-close-on-backdrop
        hide-footer
        id="modal-edit-driver"
        centered
        size="lg"
        :title="modalText"
    >
      <b-row>
        DriverID: ({{ edit.DId }})
      </b-row>
      <b-row>

        <b-col
            md="3"
            xl="3"
            class="mb-1"
        >
          <b-form-group
              label="Kürzl."
          >
            <b-form-input
                v-model="edit.DriverShortName"
            />
          </b-form-group>
        </b-col>
        <b-col
            md="3"
            xl="3"
            class="mb-1"
        >
          <b-form-group
              label="Nachname, Vorname"
          >
            <b-form-input
                v-model="edit.Contact.Name"
            />
          </b-form-group>
        </b-col>
        <b-col
            md="3"
            xl="3"
            class="mb-1"
        >
          <b-form-group
              label="Fahrzeug"
          >
            <b-form-select
                id="perPageSelect"
                v-model="edit.DefaultVehicle"
                :options="vehicleList"
            />
          </b-form-group>
        </b-col>
        <b-col
            md="3"
            xl="3"
            class="mb-1"
        >
          <b-form-group
              label="Pushover"
          >
            <b-form-select
                id="perPageSelect"
                v-model="edit.PushoverId"
                :options="pushoverList"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="Telefon 1"
          >
            <b-form-input
                v-model="edit.Contact.Phone"
            />
          </b-form-group>
        </b-col>

        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="Telefon 2"
          >
            <b-form-input
                v-model="edit.Contact.Phone2"
            />
          </b-form-group>
        </b-col>
        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="E-Mail"
          >
            <b-form-input
                v-model="edit.Contact.Email"
            />
          </b-form-group>
        </b-col>
      </b-row>


      <b-row>
        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="Eintritt"
          >
            <b-input-group>
              <b-form-input
                  v-model="edit.EntryDate"
                  type="text"
                  placeholder="DD.MM.YY"
                  autocomplete="off"
                  show-decade-nav
              />
              <b-input-group-append>
                <b-form-datepicker
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    button-only
                    :start-weekday="1"
                    locale="de-DE"
                    @context="onPickEntryDate"
                />
              </b-input-group-append>
            </b-input-group>

          </b-form-group>
        </b-col>

        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="Austritt"
          >
            <b-input-group>
              <b-form-input
                  v-model="edit.LeavingDate"
                  type="text"
                  placeholder="DD.MM.YY"
                  autocomplete="off"
                  show-decade-nav
              />
              <b-input-group-append>
                <b-form-datepicker
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    button-only
                    :start-weekday="1"
                    locale="de-DE"
                    @context="onPickLeaveDate"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="P-Schein bis"
          >
            <b-input-group>
              <b-form-input
                  v-model="edit.PassengerTransportTicket"
                  type="text"
                  placeholder="DD.MM.YY"
                  autocomplete="off"
                  show-decade-nav
              />
              <b-input-group-append>
                <b-form-datepicker
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    button-only
                    :start-weekday="1"
                    locale="de-DE"
                    @context="onPickPassengerTransportTicketDate"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="Hintergrundfarbe"
          >
            <b-input-group>
              <b-form-input
                  v-model="edit.Color1"
                  type="text"
                  placeholder="#FFFFFF"
                  autocomplete="off"
                  show-decade-nav
              />
              <b-input-group-append>

                <verte picker="square" model="hex" v-model="edit.Color1">
                  <svg viewBox="0 0 24 24">
                    <path d="M0 20h24v4H0z"/>
                    <path style="fill: #000" d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
                  </svg>
                </verte>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="Textfarbe"
          >

            <b-input-group>
              <b-form-input
                  v-model="edit.Color2"
                  type="text"
                  placeholder="#FFFFFF"
                  autocomplete="off"
                  show-decade-nav
              />
              <b-input-group-append>

                <verte picker="square" model="hex" v-model="edit.Color2">
                  <svg viewBox="0 0 24 24">
                    <path d="M0 20h24v4H0z"/>
                    <path style="fill: #000" d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
                  </svg>
                </verte>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col
            md="4"
            xl="4"
            class="mb-1"
            v-if="HasRights(10)"
        >
          <b-form-group
              label="."
          >
            <b-button
                class="btn-info"
                @click="OpenInvoice(edit.DId)"
            >
              Fahrerabrechnung
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <div>
        <b-button
            size="sm"
            variant="gradient-danger"
            class="btn-icon"
            @dblclick="DeleteRow"
            @click="DeleteRow"
        >
          <feather-icon icon="Trash2Icon"/>
        </b-button>
        <b-button class="float-right" variant="success" @click="Save">
          OK
        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormDatepicker, BFormFile,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Verte from 'verte'

export default {
  name: 'Driver',
  components: {
    BFormFile,
    Verte,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      pushoverLogo: require('@/assets/images/logo/pushover-logo.svg'),
      phoneIcon: require('@/assets/images/icons/phone-call-icon.svg'),
      modalText: 'Neuer Fahrer',
      SelectedPayrollFile: null,
      loading: {
        payroll: {
          upload : false
        }
      },
      edit: {
        DId: 0,
        DriverShortName: '',
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: '',
        },
        BankDetails: {
          AccountOwner: '',
          Iban: '',
          Bic: '',
        },
        DefaultVehicle: 0,
        Birthday: '',
        EntryDate: '',
        LeavingDate: '',
        PushoverId: 0,
        PassengerTransportTicket: '',
        HourlyWages: 0.00,
        HourlyAccount: 0.00,
        Color1: '',
        Color2: '',
      },
      currentPage: 1,
      totalRows: 0,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      FilterOptions: [{
        value: 1,
        text: "Aktive Mitarbeiter",
      },{
        value: 2,
        text: "Ausgeschiede Mitarbeiter",
      },{
        value: 0,
        text: "Alle Mitarbeiter",
      }],
      filterOption: 1,
      filter: null,
      filterTimeout: null,
      drivers: [],
      pushoverList: [],
      vehicleList: [],
      fields: [
        {
          key: 'DId',
          label: 'ID',
        },
        {
          key: 'DriverShortName',
          label: 'Kürzl.',
        },
        {
          key: 'Contact.Name',
          label: 'Name',
        },
        {
          key: 'Birthday',
          label: 'Geburtsdatum',
          formatter: (value, key, item) => {
            return value != null ? `${new Date(value).toLocaleString('de-DE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                },
            )}` : '-'
          }
        },
        {
          key: 'EntryDateLeavingDate',
          label: 'Ein/Austritt',
          formatter: (value, key, item) => {

            if (item.EntryDate != null && item.LeavingDate == null) {
              return `${new Date(item.EntryDate).toLocaleString('de-DE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  },
              )}`
            }

            if (item.EntryDate != null && item.LeavingDate != null) {
              return `${new Date(item.EntryDate).toLocaleString('de-DE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  },
              )}` + ` - ${new Date(item.LeavingDate).toLocaleString('de-DE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  },
              )}`
            }
            if (item.EntryDate == null && item.LeavingDate != null) {
              return `?` + ` - ${new Date(item.LeavingDate).toLocaleString('de-DE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  },
              )}`
            }

          }
        },
        {
          key: 'PassengerTransportTicket',
          label: 'P-Schein bis',
          formatter: (value, key, item) => {
            if (value != null) {
              if (new Date(value) < new Date()) {
                return `>>> ${new Date(value).toLocaleString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    },
                )} <<<`
              } else {
                return `${new Date(value).toLocaleString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    },
                )}`
              }
            } else {
              return '-'
            }
          }
        },
        {
          key: 'Vehicle',
          label: 'Fahrzeug',
        },
        {
          key: 'PushoverId',
          label: 'Pushover',
        },
        {
          key: 'FirmPhone',
          label: 'Weiterleitung',
        }

      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Fahrerliste'
    })
    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )

    this.$watch(
        () => this.filterOption,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.LoadVehicleList()
    this.LoadPushoverList()
    this.LoadList()
  },
  methods: {
    HasRights(id) {
      return this.$store.state.user.Rights.includes('R' + id)
    },
    OpenInvoice(did) {
      this.$router.push({
        name: 'DriverInvoice',
        params: { driver: did }
      })
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          },
      )}`
    },
    onPickEntryDate(ctx) {
      if (ctx.selectedDate) {
        this.edit.EntryDate = ctx.activeFormatted
      }
    },
    onPickLeaveDate(ctx) {
      if (ctx.selectedDate) {
        this.edit.LeavingDate = ctx.activeFormatted
      }
    },
    onPickPassengerTransportTicketDate(ctx) {
      if (ctx.selectedDate) {
        this.edit.PassengerTransportTicket = ctx.activeFormatted
      }
    },

    SetFirmPhone(id) {
      this.$http.get(`/driver/set/driver/Firm/phone?driverId=${id}`)
          .then(resp => {
            if (resp.data.success) {
              this.LoadList()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Erfolg',
                  icon: 'CheckIcon',
                  text: 'Rufweiterleitung auf ' + resp.data.driver + ' gesetzt.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadList() {
      this.$http.get(`/driver/list?option=`+this.filterOption)
          .then(resp => {
            this.drivers = [];
            resp.data.list.forEach(d => {
              this.drivers.push(d)
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadPushoverList() {
      this.pushoverList.push({
        value: 0,
        text: 'Kein Account'
      })
      this.$http.get(`/pushover/list`)
          .then(resp => {
            resp.data.list.forEach(p => {
              console.log(p)
              this.pushoverList.push({
                value: p.IdentId,
                text: p.Name
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadVehicleList() {
      this.vehicleList.push({
        value: 0,
        text: 'Keins'
      })
      this.$http.get(`/vehicle/list`)
          .then(resp => {
            resp.data.forEach(p => {
              console.log(p)
              this.vehicleList.push({
                value: p.VId,
                text: p.NumberPlate
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadRow() {

    },
    DeleteRow() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Fehler',
          icon: 'CheckIcon',
          text: 'Fahrer können aufgrund der Historic nicht gelöscht werden.',
          variant: 'danger',
        },
      })
    },
    Reset() {
      this.edit = {
        DId: 0,
        DriverShortName: '',
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: '',
        },
        BankDetails: {
          AccountOwner: '',
          Iban: '',
          Bic: '',
        },
        Birthday: '',
        EntryDate: '',
        LeavingDate: '',
        PassengerTransportTicket: '',
        HourlyWages: 0.00,
        HourlyAccount: 0.00,
      }
    },
    Save() {
      let editDriver = Object.assign({}, this.edit)
      editDriver.CallId = this.$store.state.user.callCount + '-' + new Date().getTime()

      editDriver.LeavingDate != '' ? editDriver.LeavingDate = new Date(this.edit.LeavingDate.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.LeavingDate
      editDriver.EntryDate != '' ? editDriver.EntryDate = new Date(this.edit.EntryDate.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.EntryDate
      editDriver.PassengerTransportTicket != '' ? editDriver.PassengerTransportTicket = new Date(this.edit.PassengerTransportTicket.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.PassengerTransportTicket
      editDriver.Birthday != '' ? editDriver.Birthday = new Date(this.edit.Birthday.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : delete editDriver.Birthday
      this.$http.post('driver/edit', JSON.stringify(editDriver))
          .then(resp => {
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Fahrer wurde gespeichert.',
                  variant: 'success',
                },
              })
              this.LoadList()

              this.$bvModal.hide('modal-edit-driver')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })

    },
    OpenUploadPayroll() {
      this.$bvModal.show('modal-payroll-driver')

    },
    UploadPayroll() {
      if(!this.loading.payroll.upload) {
        if (this.SelectedPayrollFile) {
          this.loading.payroll.upload = true;
          const formData = new FormData()
          formData.append('file', this.SelectedPayrollFile)
          this.$http.post('/taxoffice/add/payroll', formData, { timeout: 60000 })
              .then(resp => {
                if (resp.data.success) {

                  this.loading.payroll.upload = false;
                  this.$swal({
                    icon: 'success',
                    title: 'Erfolgreich!',
                    text: 'Datei wurde hochgeladen.',
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                      .then(result => {
                        if (result.value) {
                          this.Reset()
                        }
                      })
                }
              })
              .catch(err => {
                this.loading.payroll.upload = false;
                this.$swal({
                  icon: 'danger',
                  title: 'Fehler!',
                  text: 'Datei wurde nicht hochgeladen.',
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
                    .then(result => {
                      if (result.value) {
                        this.Reset()
                      }
                    })
                console.error(err)
              })
        }
      }


    },
    Add() {
      this.modalText = 'Neuer Fahrer'
      this.Reset()
      this.$bvModal.show('modal-edit-driver')
    },
    ClickRow(record) {
      this.$router.push({ name: 'DriverEdit', params: { driver: record.Driver.DId } })

      this.modalText = 'Fahrer bearbeiten'
      this.Reset()
      this.edit.Contact = record.Driver.Contact
      this.edit.DriverShortName = record.Driver.DriverShortName
      this.edit.DId = record.Driver.DId
      this.edit.PushoverId = record.Driver.PushoverId
      this.edit.DefaultVehicle = record.Driver.DefaultVehicle
      this.edit.Color1 = record.Driver.Color1
      this.edit.Color2 = record.Driver.Color2

      if (record.Driver.EntryDate != null) {
        this.edit.EntryDate = `${new Date(record.Driver.EntryDate).toLocaleString('de-DE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            },
        )}`
      }

      if (record.Driver.LeavingDate != null) {
        this.edit.LeavingDate = `${new Date(record.Driver.LeavingDate).toLocaleString('de-DE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            },
        )}`
      }

      if (record.Driver.PassengerTransportTicket != null) {
        this.edit.PassengerTransportTicket = `${new Date(record.Driver.PassengerTransportTicket).toLocaleString('de-DE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            },
        )}`
      }

      this.$bvModal.show('modal-edit-driver')
    }
  }
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d)
}
</script>

<style scoped>
.btn-cancel {
  color: #fff;
  background-color: rgb(213, 213, 213);
  border-color: rgb(213, 213, 213);
}
</style>
